// extracted by mini-css-extract-plugin
export default {"intro":"_2WSUquLKxVZk1tq6tHov_H"};